import { API_V1 } from '../api';
import {
	NoteMeta,
	Note,
	NoteMessage,
	NoteSortDirection,
} from './NoteModels';

export function getNoteMetadatas(discussionMessageId: string): Promise<NoteMeta[]> {
	return API_V1.get('/notes/metadata', { params: { discussionMessageId } })
		.then(({ data }) => data as NoteMeta[]);
}

export interface PageParams {
	fromMessageId: string;
	beforeLimit?: number;
	afterLimit?: number;
	sortDirection?: NoteSortDirection;
}

export function getNotePage(noteId: string, params: PageParams): Promise<Note> {
	return API_V1.get(`/notes/${noteId}`, { params })
		.then(({ data }) => data as Note);
}

interface FirstPageParams {
	beforeLimit?: number;
	afterLimit?: number;
	sortDirection?: NoteSortDirection;
}

const DEFAULT_FIRST_PAGE_PARAMS = {
	beforeLimit: 22,
	afterLimit: 23,
	sortDirection: NoteSortDirection.ASC,
};

export function getNoteFirstPage(
	noteId: string,
	userParams?: FirstPageParams,
): Promise<Note> {
	const params = { ...DEFAULT_FIRST_PAGE_PARAMS, ...userParams };
	return API_V1.get(`/notes/${noteId}/firstpage`, { params })
		.then(({ data }) => data as Note);
}

export interface CreateNotePayload {
	discussionMessageId: string;
	to: string[];
	subject: string;
	message: string;
}

export function createNote(payload: CreateNotePayload): Promise<Note> {
	return API_V1.post('/notes', payload)
		.then(({ data }) => data as Note);
}

export function markNoteMessageRead(
	noteId: string,
	noteMessageId: string,
): Promise<void> {
	return API_V1.put(`/notes/${noteId}/messages/${noteMessageId}/read`)
		.then(() => Promise.resolve());
}

export interface ReplyNotePayload {
	message: string;
}

export function replyToNote(
	noteId: string,
	payload: ReplyNotePayload,
): Promise<NoteMessage> {
	return API_V1.post(`/notes/${noteId}/reply`, payload)
		.then(({ data }) => data as NoteMessage);
}

export interface AddParticipantPayload {
	to: string[];
}

export function addParticipantsToNote(
	noteId: string,
	payload: AddParticipantPayload,
): Promise<void> {
	return API_V1.put(`/notes/${noteId}/participant`, payload)
		.then(() => Promise.resolve());
}

export function leaveNote(noteId: string): Promise<void> {
	return API_V1.delete(`/notes/${noteId}/participant`)
		.then(() => Promise.resolve());
}
